exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".psychology-tea-campus[data-v-50c1efa9] .ant-tabs-bar {\n  background-color: #fff !important;\n  margin: 0 !important;\n  border-radius: 10px 10px 0 0;\n}\n", ""]);

// exports
